import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDWizardSubtitle } from 'Views/Page/Content/Modal/Layouts/FDWizardModalWrapper/Layout/FDWizardSubtitle';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('description', {
    _component: () => FDWizardSubtitle,
  }, overrideReadOnly);

export default metaOverrideSet;
